export enum QuotationTypeEnum {
    Addendum = 'addendum',
    Quote = 'quote',
}
